import { compareDesc } from 'date-fns';

import { PeriodType } from '../../widget/date-range.widget.model';

export interface ExtCacheDateItem {
    periodTypeID: PeriodType;
    startDate: string;
    endDate: string;
    isDefault: boolean;
}

export interface CacheDateItem {
    periodType: PeriodType;
    startDate: Date;
    endDate: Date;
    eventDate: Date;
}

export function cacheDateTransformer(
    items: ExtCacheDateItem[],
): CacheDateItem[] {
    if (items == null) {
        return [];
    }
    return items
        .map((item): CacheDateItem => {
            return {
                periodType: item.periodTypeID,
                startDate: new Date(item.startDate),
                endDate: new Date(item.endDate),
                /* TODO revise. for month: ensure event date is end of month. api returned month's event date is data-cache-day event date */
                eventDate: new Date(item.endDate),
            };
        })
        .sort((a, b) => compareDesc(a.eventDate, b.eventDate));
}
